<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <EmploiOccupe />
  <EmploiVise />
</template>

<script setup lang="ts">
  import EmploiOccupe from './sections/emploiOccupe/EmploiOccupe.vue'
  import EmploiVise from './sections/emploiVise/EmploiVise.vue'
</script>
